import { render, staticRenderFns } from "./style-setting.vue?vue&type=template&id=1dfdf197&scoped=true"
import script from "./style-setting.vue?vue&type=script&lang=js"
export * from "./style-setting.vue?vue&type=script&lang=js"
import style0 from "./style-setting.vue?vue&type=style&index=0&id=1dfdf197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfdf197",
  null
  
)

export default component.exports